const regexStrings = {
    email: /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/,
    mobile: /^(\+\d{1,3}[- ]?)?\d{10}$/,
}

export const emailRegex = {
  	email: new RegExp(regexStrings.email),
}

export const mobileRegex = {
  	moblie: new RegExp(regexStrings.mobile),
}


// WEBPACK FOOTER //
// ./src/util/regExp.js